import React from "react";
import { Snackbar, Alert, Slide, useTheme, alpha } from "@mui/material";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const CustomSnackbar = ({ message, setMessage }) => {
  const theme = useTheme();

  return (
    <Snackbar
      open={Boolean(message)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      onClose={() => setMessage(null)}
      autoHideDuration={4000}
      TransitionComponent={SlideTransition}
    >
      <Alert
        elevation={0}
        variant="filled"
        onClose={() => setMessage(null)}
        severity="info"
        sx={{
          backgroundColor: alpha(theme.palette.background.paper, 0.92),
          backdropFilter: "blur(12px)",
          color: theme.palette.text.primary,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          fontWeight: 500,
          fontSize: "0.85rem",
          boxShadow: theme.palette.glass?.shadow || theme.shadows[4],
          "& .MuiAlert-icon": { color: theme.palette.primary.main },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
